import { createSelector } from 'reselect';
import { PRODUCTS_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectProductsDomain = state => state[PRODUCTS_DOMAIN] || initialState;

export const selectProducts = () => createSelector(selectProductsDomain, d => d.products);

export const selectProductFilter = () => createSelector(selectProductsDomain, d => {
  return {...d.filter, options: undefined};
});
export const selectProductFilterWithModifiers = () => createSelector(selectProductsDomain, d => d.filter);

export const selectItemsCount = () => createSelector(selectProductsDomain, d => d.itemsCount);

export const selectVehicleCounters = () => createSelector(selectProductsDomain, d => d.counters);
export const selectPaginator = () => createSelector(selectProductsDomain, d => d.paginator);
export const selectProductCompanyFinData = () => createSelector(selectProductsDomain, d => d.productCompanyFinData);
export const selectCompanyProduct = () => createSelector(selectProductsDomain, d => d.companyProduct);
export const selectCompanyProducts = () => createSelector(selectProductsDomain, d => d.companyProducts);
export const selectCompanyProductFilter = () => createSelector(selectProductsDomain, d => ({...d.companyFilter, options: undefined}));
export const selectCompanyProductFilterWithModifiers = () => createSelector(selectProductsDomain, d => d.companyFilter);
export const selectCompanyProductsIds = () => createSelector(selectProductsDomain, d => d.companyProductsIds);
export const selectCompanyPaginator = () => createSelector(selectProductsDomain, d => d.companyPaginator);
export const selectAllProductTasks = () => createSelector(selectProductsDomain, d => d.allProductTasks);
export const selectProductTasks = () => createSelector(selectProductsDomain, d => d.productTasks);
